export default "/images/co-img-4.png?e7c0a809f8289299ca19d30767f64fc8";